/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { MyndighedIdentifikation } from '../models/myndighed-identifikation';
import { AktivitetType } from '../models/aktivitet-type';
@Injectable({
  providedIn: 'root',
})
class MyndighederService extends __BaseService {
static readonly getAllPath = '/myndigheder';
static readonly getMyndighedIntroduktionTekstPath = '/myndigheder/myndighedintroduktiontekst';
static readonly getMestBrugteAktiviteterPath = '/myndigheder/mestbrugteaktiviter';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  private getAllResponse(): __Observable<__StrictHttpResponse<Array<MyndighedIdentifikation>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/myndigheder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MyndighedIdentifikation>>;
      })
    );
  }

  /**
   * @return Success
   */
  getAll(): __Observable<Array<MyndighedIdentifikation>> {
    return this.getAllResponse().pipe(
      __map(_r => _r.body as Array<MyndighedIdentifikation>)
    );
  }

  /**
   * @param myndighedKode undefined
   * @return Success
   */
  private getMyndighedIntroduktionTekstResponse(myndighedKode?: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (myndighedKode != null) __params = __params.set('myndighedKode', myndighedKode.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/myndigheder/myndighedintroduktiontekst`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param myndighedKode undefined
   * @return Success
   */
  getMyndighedIntroduktionTekst(myndighedKode?: string): __Observable<string> {
    return this.getMyndighedIntroduktionTekstResponse(myndighedKode).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param myndighedKode undefined
   * @return Success
   */
  private getMestBrugteAktiviteterResponse(myndighedKode?: string): __Observable<__StrictHttpResponse<Array<AktivitetType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (myndighedKode != null) __params = __params.set('myndighedKode', myndighedKode.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/myndigheder/mestbrugteaktiviter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AktivitetType>>;
      })
    );
  }

  /**
   * @param myndighedKode undefined
   * @return Success
   */
  getMestBrugteAktiviteter(myndighedKode?: string): __Observable<Array<AktivitetType>> {
    return this.getMestBrugteAktiviteterResponse(myndighedKode).pipe(
      __map(_r => _r.body as Array<AktivitetType>)
    );
  }
}

module MyndighederService {
}

export { MyndighederService }
